
import { buildCompanyQuestionnaire } from '@/helpers/panelcard/data-collection/companyquestionnairebuilder'
import { buildAutoEnrolmentQuestionnaire } from '@/helpers/panelcard/data-collection/autoenrolmentquestionnairebuilder'
import { buildPaymentDeductionQuestionnaire } from '@/helpers/panelcard/data-collection/paymentdeductionquestionnairebuilder'
import { buildSubcontractorQuestionnaire } from '@/helpers/panelcard/data-collection/subcontractorquestionnairebuilder'
import { buildBIKQuestionnaire } from '@/helpers/panelcard/data-collection/bikquestionnairebuilder'
import { buildOccupationalPensionQuestionnaire } from '@/helpers/panelcard/data-collection/occupationalpensionquestionnairebuilder'
import { buildHmrcAgentDelegationTask } from '@/helpers/panelcard/data-collection/hmrcagentdelegationtaskbuilder'
import { buildPensionProviderDelegationTask } from '@/helpers/panelcard/data-collection/pensionproviderdelegationtaskbuilder'
import { buildOnlineBankingQuestionnaire } from '@/helpers/panelcard/data-collection/onlinebankingquestionnairebuilder'
import { buildBACSQuestionnaire } from '@/helpers/panelcard/data-collection/bacsquestionnairebuilder'
import { buildCompanyContacts } from '@/helpers/panelcard/data-collection/companycontactsbuilder'
import { buildPayrollConfiguration } from '@/helpers/panelcard/data-collection/payrollconfigurationbuilder'
import { buildFileCollection } from '@/helpers/panelcard/file-collection/filecollectionbuilder'
import { buildPayrollRunDetails } from '@/helpers/panelcard/data-collection/payrollrundetailsbuilder'






export function getBuilders() {
  return [

    { type: 'DataCollection', schemaName: 'Company', execute: buildCompanyQuestionnaire },
    { type: 'DataCollection', schemaName: 'CompanyAutoEnrolment', execute: buildAutoEnrolmentQuestionnaire },
    { type: 'DataCollection', schemaName: 'CompanyAdditionsDeductions', execute: buildPaymentDeductionQuestionnaire },
    { type: 'DataCollection', schemaName: 'CompanyCisSubContractors', execute: buildSubcontractorQuestionnaire },
    { type: 'DataCollection', schemaName: 'CompanyBiks', execute: buildBIKQuestionnaire },
    { type: 'DataCollection', schemaName: 'CompanyPension', execute: buildOccupationalPensionQuestionnaire },
    { type: 'DataCollection', schemaName: 'HmrcAgentDelegation', execute: buildHmrcAgentDelegationTask },
    { type: 'DataCollection', schemaName: 'PensionProviderAgentDelegation', execute: buildPensionProviderDelegationTask },
    { type: 'DataCollection', schemaName: 'OnlineBanking', execute: buildOnlineBankingQuestionnaire },
    { type: 'DataCollection', schemaName: 'BACS', execute: buildBACSQuestionnaire },
    { type: 'DataCollection', schemaName: 'CompanyContacts', execute: buildCompanyContacts },
    { type: 'DataCollection', schemaName: 'PayrollConfiguration', execute: buildPayrollConfiguration },
    { type: 'DataCollection', schemaName: 'PayrollRunDetails', execute: buildPayrollRunDetails },

    { type: 'FileCollection', schemaName: 'Employee', execute: buildFileCollection },
    { type: 'FileCollection', schemaName: 'YearToDateMain', execute: buildFileCollection },
    { type: 'FileCollection', schemaName: 'YearToDateNI', execute: buildFileCollection },
    { type: 'FileCollection', schemaName: 'YearToDateStatutory', execute: buildFileCollection },
    { type: 'FileCollection', schemaName: 'YearToDateAEPension', execute: buildFileCollection },
  ];
}